const menuItemQuerySelector = '[role=menuitem]';
const toggleSubMenu = (
    element: HTMLElement,
    action: 'open' | 'close',
    changeFocus = false
) => {
    const menubarItemContainer = element.closest('[data-navigation-level=parent]');
    const associatedSubMenu = menubarItemContainer?.querySelector<HTMLElement>(
        '[data-navigation-sublinks]'
    );
    if (associatedSubMenu) {
        const ariaValue = action === 'open' ? 'true' : 'false';
        const menubarItem =
            menubarItemContainer?.querySelector<HTMLElement>(menuItemQuerySelector);
        if (menubarItem) {
            menubarItem.setAttribute('aria-expanded', ariaValue);
        }
        associatedSubMenu.dataset.navigationSublinks = action;
        if (changeFocus) {
            const itemToFocusOn =
                action === 'open'
                    ? associatedSubMenu.querySelector<HTMLElement>(menuItemQuerySelector)
                    : menubarItem;
            if (itemToFocusOn) itemToFocusOn.focus();
        }
    }
};

const openSubMenu = (element: HTMLElement, changeFocus?: boolean) => {
    toggleSubMenu(element, 'open', changeFocus);
};

const closeSubMenu = (element: HTMLElement, changeFocus?: boolean) => {
    toggleSubMenu(element, 'close', changeFocus);
};

export { openSubMenu, closeSubMenu };
